import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectAnalyticsState = (state: AppState) =>
  state.analytics;


export const selectCatchLoginEve = createSelector(
  selectAnalyticsState,
  (state) => state.catchLoginEve
);
export const selectCatchInstantLoginEve = createSelector(
  selectAnalyticsState,
  (state) => state.catchInstantLoginEve
);